import React from 'react'
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { useTranslation } from "react-i18next";

export default function TerminModal({ open, onCloseModal }) {
    const { t } = useTranslation();

    const doctorLinks = [
        {
            id: 1,
            name: 'Dr. Anil Bharwani',
            link: 'https://www.doctolib.de/internist/grevenbroich/anilkumar-bharwani-grevenbroich/booking/motives?specialityId=1286&telehealth=false&placeId=practice-759798&insuranceSectorEnabled=false&insuranceSector=public&pid=practice-759798&insurance_sector=public&source=profile',
        },
    ];

    return (
        <Modal
            open={open}
            onClose={onCloseModal}
            center
            focusTrapped={false}
            classNames={{
                overlay: 'prescription-modal-overlay',
                modal: 'prescription-modal',
            }}
        >
            <div className="prescription-modal-scroll">
                <div className="prescription-modal-header">
                    <div className="prescription-modal-icon">
                        <i className="fi flaticon-calendar"></i>
                    </div>
                    <p className="prescription-modal-kicker">{t('termin_modal_title')}</p>
                </div>

                <div className="prescription-modal-content">
                    <h2>{t('termin_modal_title')}</h2>
                    <p>{t('termin_modal_subtitle')}</p>
                </div>

                <div className="prescription-modal-actions" style={{ marginTop: 32 }}>
                    <button
                        className="theme-btn"
                        style={{ background: 'transparent', color: '#0d1b5e', border: '2px solid #0d1b5e' }}
                        onClick={onCloseModal}
                    >
                        {t('termin_modal_cancel') || 'Return to Homepage'}
                    </button>
                    {doctorLinks.map((doctor) => (
                        <button
                            key={doctor.id}
                            className="theme-btn"
                            onClick={() => { window.open(doctor.link, '_blank'); onCloseModal(); }}
                        >
                            {t('termin_modal_confirm') || 'Continue to Doctolib'}
                        </button>
                    ))}
                </div>
            </div>
        </Modal>
    );
}


